export default "__VITE_ASSET__Azbf3OgR__"